import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { skip } from 'rxjs';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';
import { Modal } from 'bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-add-audit-conducted',
  templateUrl: './add-audit-conducted.component.html',
  styleUrls: ['./add-audit-conducted.component.scss']
})
export class AddAuditConductedComponent implements OnInit {
  targetForm!: FormGroup;
  auditForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  circlesList: any[] = [];
  auditData: any[] = [];
  UserDetails: any;
  currentMonth: any = {};
  showButton = false;


  constructor(private fb: FormBuilder,private authService: AuthService, private reportService: ReportsService, private toastService: ToastService) { }

  ngOnInit(): void {
    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],
    });

    this.auditForm = this.fb.group({
      totalSocieties: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      societiesToBeAudited: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      previousYear: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      currentYear: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      total: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      percentage: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      arrearAsOn: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      currentYearArrear: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      previousYearArrear: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
      totalArrear: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
    });

    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;
    this.getAuditConducted();

    if (this.UserDetails?.roleId == 11) {
      const userBlock = this.UserDetails?.iBlockId;

      this.targetForm.controls['blockOffice'].setValue(userBlock);
      this.targetForm.controls['blockOffice'].disable();


    }

    this.GetBlock();
    this.getTargetCount();
    
      switch (this.UserDetails?.roleId) {
        case 13:

          break;
        case 1:
          this.targetForm.addControl('circleOffice', new FormControl({
            value: '',
            disabled: false
          }, Validators.required));
          this.getCircle();
          break;
        case 11:
          this.targetForm.controls['blockOffice'].disable();
          this.targetForm.get('blockOffice')?.valueChanges
            .pipe(skip(1))
            .subscribe((val: any) => {
              if (this.targetForm.valid) {
                this.getTargetCount();
              }
            });

          break;
        default:
      }
  }

  getMonthName(month: number) {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[month - 1];
  }

  addData() {
    this.auditForm.patchValue({
      financialYear: this.targetForm.value?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth: this.currentMonth.key
    });
  }




  getCircle() {
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
      }
    },
      (error: any) => {
      }
    );
  }


  GetBlock() {
    let obj = {
      "blockId": 0,
      "circleId":  this.targetForm.value.circleOffice
    }

    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
        this.blockList = res.data?.block;
        //this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }

  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {

        this.financialYears = res.data.financialYears
      }
    },
      (error: any) => {
      }
    );
  }

  isInvalid(controlName: string): boolean {
    const control = this.auditForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }


  onSubmit(): void {
    if (this.auditForm.invalid) {
      this.auditForm.markAllAsTouched();
      return;
    }
    const formData: any = this.auditForm.getRawValue();
    const finalObj = {
      id: this.edit ? this.editId : 0,
      blockId: Number(this.targetForm.getRawValue().blockOffice) || 0,
      financialYear: this.targetForm.getRawValue().financialYear || '',
      dataMonth: new Date().getMonth() + 1, // e.g., current month number
      totalSocieties: Number(formData.totalSocieties) || 0,
      auditedSocieties: Number(formData.societiesToBeAudited) || 0,
      previousYear: Number(formData.previousYear) || 0,
      currentYear: Number(formData.currentYear) || 0,
      total: Number(formData.total) || 0,
      percentage: Number(formData.percentage) || 0,
      asOnArrear: Number(formData.arrearAsOn) || 0,
      currentYearArrear: Number(formData.currentYearArrear) || 0,
      previousYearArrear: Number(formData.previousYearArrear) || 0,
      totalArrear: Number(formData.totalArrear) || 0
    }


    this.reportService.addAuditCounducted(finalObj).subscribe(res => {
      if (res) {
        if (res?.status == 200) {
          this.hideModal('addAuditConductedDataModal');
          this.toastService.showSuccess(res.message);
          this.getAuditConducted();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  getAuditConducted() {

    let obj = {
      "blockId": this.targetForm.value.blockOffice,
      "financialYear": this.targetForm.value.financialYear,
    }

    this.reportService.getAuditCounducted(obj).subscribe((res: any) => {
      if (res) {
        if (res && res?.data && res?.data.length > 0) {
          this.auditData = res?.data;
          // this.showButton = true
          const currentMonthExists = this.auditData.some(
            (x: any) => x.dataMonth == this.currentMonth.key
          );

          if (currentMonthExists) {
            this.showButton = true;
          } else {
            this.showButton = false;
          }
        } else {
          this.auditData = []
          this.showButton = true;
          this.currentMonth.key = '1';
          this.toastService.showInfo('NO Data Found!')
        }
      }
    },
      (error: any) => {
      }
    );
  }

  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }


  deleteAuditConducted(id: any) {
    this.reportService.DeleteAuditConducted(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.getAuditConducted();
          window.location.reload();
        }

      }
    },
      (error: any) => {
      }
    );
  }
  closeModel() {
    this.auditForm.reset()
    this.auditForm.markAsUntouched()
    //   this.editId = 0
    // this.edit =false
  }

  verifyAuditConducted(id: any) {
    this.reportService.verifyaAuditConducted(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.getAuditConducted();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete() {
    this.deleteIndex = 0;

  }

  edit = false;
  editId = 0
  editRow(row: any) {
    const headerData: any = row;
    // const headerData = this.auditForm.getRawValue();
    let year = this.financialYears.find((i) => i?.financialYear == row?.financialYear)
    this.auditForm.patchValue({
      id: Number(headerData?.Id),
      blockId: Number(headerData.blockID),
      financialYear: headerData.financialYear?.financialYear,


      totalSocieties: Number(headerData.totalSocieties),
      societiesToBeAudited: Number(headerData.auditedSocieties),
      previousYear: Number(headerData.previousYear),
      currentYear: Number(headerData.currentYear),
      total: Number(headerData.total),
      percentage: Number(headerData.percentage),
      arrearAsOn: Number(headerData.asOnArrear),
      currentYearArrear: Number(headerData.currentYearArrear),
      previousYearArrear: Number(headerData.previousYearArrear),
      totalArrear: Number(headerData.totalArrear)
    });


    this.editId = headerData?.id
    this.edit = true

    this.openModal('addAuditConductedDataModal');
  }


  onlyNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      return false;
    }
    return true;
  }

}

